module.exports = __webpack_public_path__ + "img/usb.ac07c06f.svg";